import { render, staticRenderFns } from "./Blocker.vue?vue&type=template&id=446897ef&scoped=true&"
import script from "./Blocker.vue?vue&type=script&lang=js&"
export * from "./Blocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446897ef",
  null
  
)

export default component.exports